import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { assert } from '@ember/debug';
import Disclosure from 'core/components/disclosure';
/**
 *
 * A collapsing and stackable Disclosure-like UI that renders a title translation string
 * and yields it block content within its collapsible area
 *
 * ```
 * <Networks::Accordion
 *   @label={{label}}
 *   @isIntiallyOpen={{isIntiallyOpen}}
 * />
 * ```
 *
 * @class NetworksAccordion
 *
 */ /**
 * `label` is a optional string that is rendered inside of the <summary> element
 *  as an accordion header.
 * @argument title
 * @type {string}
 */ /**
 * `isIntiallyOpen` is a boolean that sets the accordion to an initial open or closed state on render
 * @argument isIntiallyOpen
 * @type {boolean}
 */ /**
 * `displayBadge` is a boolean that sets the accordion to display a badge
 * @argument displayBadge
 * @type {boolean}
 */ /**
 * `isSuccess` is a boolean that sets the accordion to display a Success badge
 * @argument isSuccess
 * @type {boolean}
 */ /**
 * `isOptional` is a boolean that sets the accordion to display an Optional badge
 * @argument isOptional
 * @type {boolean}
 */ export default class NetworksAccordion extends Component {
    get badge() {
        let { isSuccess: isSuccess1, isOptional: isOptional1 } = this.args;
        if (isSuccess1 && isOptional1) {
            assert('<Networks::Accordion/> was passed both isSuccess and isOptional as boolean true args, this is invalid');
        }
        if (isSuccess1) {
            return {
                text: 'Marked Complete',
                color: 'success',
                icon: 'check',
                size: 'small'
            };
        } else if (isOptional1) {
            return {
                text: 'Optional',
                size: 'small'
            };
        } else {
            return null;
        }
    }
    static{
        template(`
    <Disclosure
      @isInitiallyOpen={{@isInitiallyOpen}}
      @label={{@label}}
      @openLabel={{@openLabel}}
      @badge={{if @displayBadge this.badge}}
      class="networks-connection-instructions-accordion"
      data-test-networks-connection-accordion
      ...attributes
    >
      {{yield}}
    </Disclosure>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci9hY3Rpb25zLXJ1bm5lci9fd29yay9jbG91ZC11aS9jbG91ZC11aS9hZGRvbnMvbmV0d29ya3MtY29tbW9uL3BhY2thZ2Uvc3JjL2NvbXBvbmVudHMvbmV0d29ya3MvYWNjb3JkaW9uLmdqcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgQ29tcG9uZW50IGZyb20gJ0BnbGltbWVyL2NvbXBvbmVudCc7XG5pbXBvcnQgeyBhc3NlcnQgfSBmcm9tICdAZW1iZXIvZGVidWcnO1xuaW1wb3J0IERpc2Nsb3N1cmUgZnJvbSAnY29yZS9jb21wb25lbnRzL2Rpc2Nsb3N1cmUnO1xuXG4vKipcbiAqXG4gKiBBIGNvbGxhcHNpbmcgYW5kIHN0YWNrYWJsZSBEaXNjbG9zdXJlLWxpa2UgVUkgdGhhdCByZW5kZXJzIGEgdGl0bGUgdHJhbnNsYXRpb24gc3RyaW5nXG4gKiBhbmQgeWllbGRzIGl0IGJsb2NrIGNvbnRlbnQgd2l0aGluIGl0cyBjb2xsYXBzaWJsZSBhcmVhXG4gKlxuICogYGBgXG4gKiA8TmV0d29ya3M6OkFjY29yZGlvblxuICogICBAbGFiZWw9e3tsYWJlbH19XG4gKiAgIEBpc0ludGlhbGx5T3Blbj17e2lzSW50aWFsbHlPcGVufX1cbiAqIC8-XG4gKiBgYGBcbiAqXG4gKiBAY2xhc3MgTmV0d29ya3NBY2NvcmRpb25cbiAqXG4gKi9cblxuLyoqXG4gKiBgbGFiZWxgIGlzIGEgb3B0aW9uYWwgc3RyaW5nIHRoYXQgaXMgcmVuZGVyZWQgaW5zaWRlIG9mIHRoZSA8c3VtbWFyeT4gZWxlbWVudFxuICogIGFzIGFuIGFjY29yZGlvbiBoZWFkZXIuXG4gKiBAYXJndW1lbnQgdGl0bGVcbiAqIEB0eXBlIHtzdHJpbmd9XG4gKi9cblxuLyoqXG4gKiBgaXNJbnRpYWxseU9wZW5gIGlzIGEgYm9vbGVhbiB0aGF0IHNldHMgdGhlIGFjY29yZGlvbiB0byBhbiBpbml0aWFsIG9wZW4gb3IgY2xvc2VkIHN0YXRlIG9uIHJlbmRlclxuICogQGFyZ3VtZW50IGlzSW50aWFsbHlPcGVuXG4gKiBAdHlwZSB7Ym9vbGVhbn1cbiAqL1xuXG4vKipcbiAqIGBkaXNwbGF5QmFkZ2VgIGlzIGEgYm9vbGVhbiB0aGF0IHNldHMgdGhlIGFjY29yZGlvbiB0byBkaXNwbGF5IGEgYmFkZ2VcbiAqIEBhcmd1bWVudCBkaXNwbGF5QmFkZ2VcbiAqIEB0eXBlIHtib29sZWFufVxuICovXG5cbi8qKlxuICogYGlzU3VjY2Vzc2AgaXMgYSBib29sZWFuIHRoYXQgc2V0cyB0aGUgYWNjb3JkaW9uIHRvIGRpc3BsYXkgYSBTdWNjZXNzIGJhZGdlXG4gKiBAYXJndW1lbnQgaXNTdWNjZXNzXG4gKiBAdHlwZSB7Ym9vbGVhbn1cbiAqL1xuXG4vKipcbiAqIGBpc09wdGlvbmFsYCBpcyBhIGJvb2xlYW4gdGhhdCBzZXRzIHRoZSBhY2NvcmRpb24gdG8gZGlzcGxheSBhbiBPcHRpb25hbCBiYWRnZVxuICogQGFyZ3VtZW50IGlzT3B0aW9uYWxcbiAqIEB0eXBlIHtib29sZWFufVxuICovXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIE5ldHdvcmtzQWNjb3JkaW9uIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgZ2V0IGJhZGdlKCkge1xuICAgIGxldCB7IGlzU3VjY2VzcywgaXNPcHRpb25hbCB9ID0gdGhpcy5hcmdzO1xuXG4gICAgaWYgKGlzU3VjY2VzcyAmJiBpc09wdGlvbmFsKSB7XG4gICAgICBhc3NlcnQoXG4gICAgICAgICc8TmV0d29ya3M6OkFjY29yZGlvbi8-IHdhcyBwYXNzZWQgYm90aCBpc1N1Y2Nlc3MgYW5kIGlzT3B0aW9uYWwgYXMgYm9vbGVhbiB0cnVlIGFyZ3MsIHRoaXMgaXMgaW52YWxpZCcsXG4gICAgICApO1xuICAgIH1cblxuICAgIGlmIChpc1N1Y2Nlc3MpIHtcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHRleHQ6ICdNYXJrZWQgQ29tcGxldGUnLFxuICAgICAgICBjb2xvcjogJ3N1Y2Nlc3MnLFxuICAgICAgICBpY29uOiAnY2hlY2snLFxuICAgICAgICBzaXplOiAnc21hbGwnLFxuICAgICAgfTtcbiAgICB9IGVsc2UgaWYgKGlzT3B0aW9uYWwpIHtcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHRleHQ6ICdPcHRpb25hbCcsXG4gICAgICAgIHNpemU6ICdzbWFsbCcsXG4gICAgICB9O1xuICAgIH0gZWxzZSB7XG4gICAgICByZXR1cm4gbnVsbDtcbiAgICB9XG4gIH1cblxuICA8dGVtcGxhdGU-XG4gICAgPERpc2Nsb3N1cmVcbiAgICAgIEBpc0luaXRpYWxseU9wZW49e3tAaXNJbml0aWFsbHlPcGVufX1cbiAgICAgIEBsYWJlbD17e0BsYWJlbH19XG4gICAgICBAb3BlbkxhYmVsPXt7QG9wZW5MYWJlbH19XG4gICAgICBAYmFkZ2U9e3tpZiBAZGlzcGxheUJhZGdlIHRoaXMuYmFkZ2V9fVxuICAgICAgY2xhc3M9XCJuZXR3b3Jrcy1jb25uZWN0aW9uLWluc3RydWN0aW9ucy1hY2NvcmRpb25cIlxuICAgICAgZGF0YS10ZXN0LW5ldHdvcmtzLWNvbm5lY3Rpb24tYWNjb3JkaW9uXG4gICAgICAuLi5hdHRyaWJ1dGVzXG4gICAgPlxuICAgICAge3t5aWVsZH19XG4gICAgPC9EaXNjbG9zdXJlPlxuICA8L3RlbXBsYXRlPlxufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLGVBQWUscUJBQXFCO0FBQzNDLFNBQVMsTUFBTSxRQUFRLGVBQWU7QUFDdEMsT0FBTyxnQkFBZ0IsNkJBQTZCO0FBRXBEOzs7Ozs7Ozs7Ozs7OztDQWNDLEdBRUQ7Ozs7O0NBS0MsR0FFRDs7OztDQUlDLEdBRUQ7Ozs7Q0FJQyxHQUVEOzs7O0NBSUMsR0FFRDs7OztDQUlDLEdBRUQsZUFBZSxNQUFNLDBCQUEwQjtJQUM3QyxJQUFJLFFBQVE7UUFDVixJQUFJLEVBQUUsV0FBQSxVQUFTLEVBQUUsWUFBQSxXQUFVLEVBQUUsR0FBRyxJQUFJLENBQUMsSUFBSTtRQUV6QyxJQUFJLGNBQWEsYUFBWTtZQUMzQixPQUNFO1FBRUo7UUFFQSxJQUFJLFlBQVc7WUFDYixPQUFPO2dCQUNMLE1BQU07Z0JBQ04sT0FBTztnQkFDUCxNQUFNO2dCQUNOLE1BQU07WUFDUjtRQUNGLE9BQU8sSUFBSSxhQUFZO1lBQ3JCLE9BQU87Z0JBQ0wsTUFBTTtnQkFDTixNQUFNO1lBQ1I7UUFDRixPQUFPO1lBQ0wsT0FBTztRQUNUO0lBQ0Y7SUFFQSxNQUFBO1FBQUEsU0FBVSxDQUFBOzs7Ozs7Ozs7Ozs7RUFZVixDQUFBLEVBQUE7WUFBQSxXQUFBLElBQVc7WUFBWDtnQkFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7WUFBRDtRQUFBO0lBQUEsQ0FaQTtBQWFaIn0